import { create, enforce, test } from 'vest';

import { isEmail, isPhoneNumber } from 'components/Common/Form/FormValidations';
import { CANADA } from 'components/OnlineBooking/Steps/ContactDetailsStep/ContactDetailsStep';

import { ContactDetailsValues } from '../../state/types';

export const usZipCodeRegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const caZipCodeRegExp = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

const suite = create((values: ContactDetailsValues) => {
  test('firstName', () => {
    enforce(values.firstName).message('First name is required').isNotEmpty();
  });
  test('lastName', () => {
    enforce(values.lastName).message('Last name is required').isNotEmpty();
  });

  test('phone', () => {
    enforce(values.phone).message('Phone number is required').isNotEmpty();
    enforce(values.phone)
      .message('Phone number is not valid')
      .condition((value) => isPhoneNumber(value));
  });

  test('email', () => {
    enforce(values.email).message('E-mail address is required').isNotEmpty();
    enforce(values.email)
      .message('E-mail address is not valid')
      .condition((value) => {
        return isEmail(value);
      });
  });

  test('country', () => {
    enforce(values.country).message('Country is required').isNotEmpty();
  });

  const isCanada = values.country === CANADA;

  test('addressLine1', () => {
    enforce(values.addressLine1).message('Street address is required').isNotEmpty();
  });

  test('state', () => {
    enforce(values.state)
      .message(`${isCanada ? 'Province' : 'State'} is required`)
      .isNotEmpty();
    enforce(values.state)
      .message(`Please use ${isCanada ? 'province' : 'state'} abbreviation`)
      .lengthEquals(2);
  });

  test('city', () => {
    enforce(values.city).message('City is required').isNotEmpty();
  });

  test('zipCode', () => {
    enforce(values.zipCode)
      .message(`${isCanada ? 'Postal' : 'Zip'} code is required`)
      .isNotEmpty();
    enforce(values.zipCode)
      .message(`${isCanada ? 'Postal' : 'Zip'} code is not valid`)
      .condition((value) => (values.country === 'Canada' ? caZipCodeRegExp : usZipCodeRegExp).test(value));
  });
});

export const onValidate = (values: ContactDetailsValues) => {
  const { getErrors } = suite(values);
  return getErrors();
};
